import React, { useState, useEffect } from "react";
import "./css/styles.css";
import CreativeImage from "./CreativeImage";
import {
  Card,
  Box,
  Button,
  Container,
  MenuItem,
  Modal,
  Select,
  Tab,
  Tabs,
  Typography,
  CardContent,
  CardMedia,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import axios from "axios";
import { db, storage, app } from "../firebase";

import { set } from "date-fns";
import { writeBatch } from "firebase/firestore";
import {
  collection,
  getDocs,
  setDoc,
  updateDoc,
  doc,
  query,
  orderBy,
  getDoc,
} from "firebase/firestore";
const VisaRequirement = () => {
  const [countries, setCountries] = useState([]);
  const [Requirements, setRequirements] = useState([]);
  const [matchedData, setMatchedData] = useState([]);

  const [selectedCountry, setSelectedCountry] = useState("");
  const [open, setOpen] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const [passportImage, setPassportImage] = useState("");
  const [selectedCountryId, setSelectedCountryId] = useState("");
  const Image = "https://www.passportindex.org/countries/af.png";
  useEffect(() => {
    const getData = async () => {
      const querySnapshot = await getDocs(collection(db, "countries"));
      const countriesData = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        name: doc.data().name,
      }));
      const filteredCountries = countriesData.filter(
        (country) => !country.name.includes(" ")
      );
      setCountries(filteredCountries);
      console.log(countriesData, "countriesData");
    };
    getData();
  }, []);

  useEffect(() => {
    if (selectedCountryId) {
      const match = Requirements.find((item) => item.id === selectedCountryId);
      //   console.log(match, "match");
      setMatchedData(match ? match.data : []);
    }
  }, [selectedCountryId, Requirements]);

  //   console.log(matchedData, "object");
  //   useEffect(() => {
  //     const fetchData = async () => {
  //       try {
  //         const response = await axios.get(
  //           "https://passportindex.org/passport/armenia/"
  //         );
  //         console.log(response.data, "asasas"); // Logging the HTML content
  //       } catch (error) {
  //         console.error("Error fetching data:", error);
  //       }
  //     };

  //     fetchData();
  //   }, []);
  const PassportData = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "passportIndex"));
      const PassportData = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      console.log(PassportData, "PassportData");
      setRequirements(PassportData);

      return PassportData; // Return the array of treaty documents
    } catch (error) {
      console.error("Error fetching treaties:", error);
      return []; // Return empty array on error
    }
  };
  useEffect(() => {
    PassportData();
  }, []);
  //   useEffect(() => {
  //     const image = getPassportImage();
  //     console.log(image, "image");
  //     setPassportImage(image);
  //   });

  const handleCountryChange = (event) => {
    setSelectedCountryId(event.target.value);
    const selectedCountryData = countries.find(
      (country) => country.id === event.target.value
    );
    setSelectedCountry(selectedCountryData.name);
    // console.log(event.target.value, "event.target.value");
  };
  const handleContinue = () => {
    if (selectedCountryId) {
      setOpen(true);
      setTabIndex(1);
    }
  };

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const handleReset = () => {
    setSelectedCountry("");
    setOpen(false);
    setTabIndex(0);
  };
  const visaRequirementhandler = () => {
    setTabIndex(2);
  };

  //   const filteredCountries = countriesData.filter(country => !country.name.includes(' '));
  const countryname = selectedCountry.toLowerCase();
  //   const getPassportImage = () => {
  //     const selectedCountryData = countries.find(
  //       (country) =>
  //         country.countryName.toLowerCase() === selectedCountry.toLowerCase()
  //     );
  //     return selectedCountryData ? selectedCountryData.passportImage : "";
  //   };
  const url = `https://passportindex.org/passport/${countryname}/`;
  return (
    <div>
      <div
        style={{
          width: "100%",
          padding: 40,
          paddingRight: 20,

          backgroundColor: "#212C62",
        }}
      >
        <Card style={{ padding: 50, borderRadius: 10 }}>
          <div className="row d-flex justify-content-between">
            <div className="col-6">
              <h1
                className="mb-4 py-4"
                style={{ textAlign: "left", color: "#212C62" }}
              >
                <b>Visa Requirements</b>
              </h1>
            </div>
            <div
              className="col-6 d-flex justify-content-end"
              style={{ marginTop: "-30px" }}
            >
              <CreativeImage />
            </div>
          </div>
          <Container>
            <Box mt={4}>
              {/* <Typography variant="h4" gutterBottom>
                Passport Viewer
              </Typography> */}
              <Tabs value={tabIndex} onChange={handleTabChange} centered>
                <Tab label="Choose Country" />
                <Tab label="Passport" disabled={!selectedCountry} />
                <Tab label="Visa Requirement" disabled={!selectedCountry} />
              </Tabs>
              {tabIndex === 0 && (
                <Box>
                  <Select
                    value={selectedCountryId}
                    onChange={handleCountryChange}
                    fullWidth
                  >
                    <MenuItem value="" disabled>
                      Select a country
                    </MenuItem>
                    {countries.map((country) => (
                      <MenuItem key={country.id} value={country.id}>
                        {country.name}
                      </MenuItem>
                    ))}
                  </Select>
                  {/* <select
                    value={selectedCountryId}
                    onChange={handleCountryChange}
                  >
                    <option value="">Select a country</option>
                    {countries.map((country) => (
                      <option key={country.id} value={country.id}>
                        {country.name}
                      </option>
                    ))}
                  </select> */}
                  <Box mt={2}>
                    <Button variant="contained" onClick={handleContinue}>
                      Continue
                    </Button>
                  </Box>
                </Box>
              )}
              {tabIndex === 1 && (
                <Modal open={open} onClose={() => setOpen(false)}>
                  <Box
                    sx={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      bgcolor: "background.paper",
                      boxShadow: 24,
                      p: 4,
                      maxWidth: 400,
                    }}
                  >
                    <Typography variant="h5" gutterBottom>
                      `Passport of {selectedCountry}`
                    </Typography>
                    <Box mt={2}>
                      <img src={Image} alt={`Passport of ${selectedCountry}`} />
                    </Box>
                    <Box mt={2}>
                      <Button
                        variant="contained"
                        onClick={visaRequirementhandler}
                      >
                        View Passport Requirements
                      </Button>
                    </Box>
                    <Box mt={2}>
                      <Button variant="contained" onClick={handleReset}>
                        Choose Another Country
                      </Button>
                    </Box>
                  </Box>
                </Modal>
              )}
            </Box>
          </Container>
          {tabIndex === 2 && (
            <TableContainer component={Paper}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="left">Passport Image</TableCell>
                    <TableCell>Country Name</TableCell>
                    <TableCell align="right">Visa Requirement</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {matchedData.map((country) => (
                    <TableRow
                      key={country.id}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell align="left">
                        <img
                          src={country.passportImage}
                          alt={`Passport of ${country.countryName}`}
                          style={{ width: 100 }}
                        />
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {country.countryName}
                      </TableCell>
                      <TableCell align="right">
                        {country.visaRequirement
                          .toLowerCase()
                          .includes("evisa") ? (
                          <a
                            style={{ color: "black" }}
                            target="_blank"
                            href="https://e-visa.al"
                          >
                            {country.visaRequirement}
                          </a>
                        ) : (
                          country.visaRequirement
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Card>
      </div>
    </div>
  );
};

export default VisaRequirement;
